import React from "react";
import { Form, InputNumber } from "antd";

const TotalPrice = ({ form, disabled, className, parent }) => {
  const { getFieldDecorator } = form;
  return (
    <div className={className ? className : "offer-card__item"}>
      <span className="label">
        <span>
          Итоговая цена {parent === "order" ? "заказа" : "предложения"}{" "}
          (с&nbsp;учетом&nbsp;НДС), руб:
        </span>
      </span>
      <Form.Item>
        {getFieldDecorator("totalPrice")(
          <InputNumber style={{ width: 224 }} disabled={disabled} />
        )}
      </Form.Item>
    </div>
  );
};

export default TotalPrice;
